'use strict';

angular.module('internal.licenses')
    .directive('internalLicenseNavigation', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'licenses/components/license-navigation/license-navigation.html',
            replace: true,
            controller: 'InternalNavigation'
        };
    }])
;